"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoTitle = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const layout_1 = require("../../../../base/layout");
const popup_1 = require("../../../../base/popup");
const DSTL001_Submit_View_1 = require("../../DSTL001_Submit_View");
const server_1 = require("../../../../../server");
exports.InfoTitle = react_1.default.memo(({ isTeacher = false, isTest, isSurvey = false, title, statusText, test_id, previousPage, testSelector, hideTitle = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const openAssignment = () => {
        if (isMobile) {
            APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                menuDetail: 'submit_view',
                id: test_id,
            });
        }
        else {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: DSTL001_Submit_View_1.DSTL001_Submit_View,
                componentProps: { test_id, isPreview: true, isSurvey },
                width: 757,
                title: isTest
                    ? '테스트 보기'
                    : isSurvey
                        ? t('assignment.showSurvey')
                        : t('assignment.show'),
            });
        }
    };
    const downloadAssignment = () => {
        (0, server_1.downloadStatistics)(test_id);
    };
    return (react_1.default.createElement(layout_1.DetailTitleInfo, { title: react_1.default.createElement("div", { className: "title-inline-wrap", style: hideTitle ? { visibility: 'hidden' } : undefined },
            statusText && react_1.default.createElement("span", { className: "title-status-chip" }, statusText),
            react_1.default.createElement("span", { className: "title-main-text" }, title)), previousPage: previousPage },
        react_1.default.createElement("div", { className: "btn-container", style: { margin: 0 } },
            isTeacher && isDesktop && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: isTest
                        ? '테스트 보기'
                        : isSurvey
                            ? t('assignment.showSurvey')
                            : t('assignment.show'), onClick: openAssignment }),
                react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('common.download'), onClick: downloadAssignment }))),
            !isTeacher && isDesktop && testSelector)));
});
